export default __webpack_public_path__ + "static/N0141-6bf1ceeae61f8f6e4ed981c2575434e9.png";